import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
  BooleanField,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const BotExchangeList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_exchange_id",
        title: "Bot Exchange Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "bot_id",
        title: "Bot Id",
        width: 200,
        type: "number",
      },
      {
        dataIndex: "check_affiliate",
        title: "Check Affiliate",
        type: "boolean",
        width: 150,
        render: (_, record) => {
          return (
            <BooleanField
              value={record.check_affiliate === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        },
      },
      {
        dataIndex: "exchange",
        title: "Exchange",
        type: "string",
        width: 100,
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.bot_exchange_id} />
              <DeleteButton hideText recordItemId={record.bot_exchange_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="bot_exchange_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
